/* Marks the document as keyboard driven so the focus ring shows for Tab users
   and never after a click or a tap. Set on the first Tab, cleared on the next
   pointer press. See the comment in anyra-global.css. */
(() => {
  const on = () => document.documentElement.classList.add('anyra-kb');
  const off = () => document.documentElement.classList.remove('anyra-kb');
  addEventListener('keydown', (e) => { if (e.key === 'Tab') on(); }, true);
  addEventListener('mousedown', off, true);
  addEventListener('touchstart', off, { capture: true, passive: true });
})();
